import { pb } from './pocketbase';

// Récupérer toutes les demandes de contact
export const getContactRequests = async (options = {}) => {
  try {
    const {
      page = 1,
      perPage = 50,
      sort = '-created',
      filter = '',
      search = ''
    } = options;

    let finalFilter = filter;
    
    // Ajouter la recherche par nom ou email si fournie
    if (search) {
      const searchFilter = `(nom ~ "${search}" || email ~ "${search}")`;
      finalFilter = finalFilter ? `${finalFilter} && ${searchFilter}` : searchFilter;
    }

    const result = await pb.collection('contact_requests').getList(page, perPage, {
      sort,
      filter: finalFilter,
    });

    return {
      items: result.items,
      totalPages: result.totalPages,
      totalItems: result.totalItems,
      page: result.page,
      perPage: result.perPage
    };
  } catch (error) {
    console.error('Erreur lors de la récupération des demandes de contact:', error);
    throw error;
  }
};

// Récupérer une demande de contact par ID
export const getContactRequestById = async (id) => {
  try {
    const contactRequest = await pb.collection('contact_requests').getOne(id);
    return contactRequest;
  } catch (error) {
    console.error('Erreur lors de la récupération de la demande de contact:', error);
    throw error;
  }
};

// Mettre à jour le statut d'une demande de contact
export const updateContactRequestStatus = async (id, status, processedAt = null) => {
  try {
    const updateData = { 
      status,
      processed_at: processedAt || new Date().toISOString()
    };
    
    const updatedRequest = await pb.collection('contact_requests').update(id, updateData);
    return updatedRequest;
  } catch (error) {
    console.error('Erreur lors de la mise à jour du statut:', error);
    throw error;
  }
};

// Supprimer une demande de contact
export const deleteContactRequest = async (id) => {
  try {
    await pb.collection('contact_requests').delete(id);
    return { success: true };
  } catch (error) {
    console.error('Erreur lors de la suppression de la demande de contact:', error);
    throw error;
  }
};

// Supprimer plusieurs demandes de contact
export const deleteMultipleContactRequests = async (ids) => {
  try {
    const deletePromises = ids.map(id => pb.collection('contact_requests').delete(id));
    await Promise.all(deletePromises);
    return { success: true, deletedCount: ids.length };
  } catch (error) {
    console.error('Erreur lors de la suppression multiple:', error);
    throw error;
  }
};
